module.exports = __webpack_public_path__ + "img/fxdt_tab_personal_icon@2x.70d54f1b.png";